import React from "react";

const Blog2 = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1 data-aos="fade" className="text-main-black text-34 font-semibold w-full text-center max-w-[420px]">
                Why wellness OPD plans are a smart investment
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto w-full">
          <div className="grid grid-cols-6 md:grid-cols-12 items-center">
            <div className="col-span-6">
              <h1 className="text-24 sm:text-34 leading-[55px] tracking-tight font-semibold text-main-black">
                Overview
              </h1>
              <p className="max-w-[533px] text-16 sm:text-24 leading-[40px] text-paragraph mt-2.5 md:mt-3.5">
                Health is our most valuable asset, yet many of us only pay attention to it when things go wrong. In the hustle and bustle of everyday life, it’s easy to overlook routine checkups or ignore minor symptoms. However, Wellness OPD plans are designed to make maintaining your health simple, affordable, and proactive. These plans not only provide a comprehensive health check-up but also offer a wide range of services to help you maintain your health and detect issues early.
              </p>
            </div>
            <div className="col-span-6 flex justify-center items-center mt-5 md:mt-0">
              <img
                src="assets/images/home-three/blogs/2.jpg"
                alt=""
                className="w-full rounded-[40px]"
              />
            </div>
          </div>
          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            Understanding the Value of Wellness OPD Plans
          </h4>
          <p className="text-paragraph mt-[10px]">
            One of the key benefits of Wellness OPD is that it goes beyond just treating illness — it’s all about prevention. These plans provide you with consistent access to healthcare services that help you stay ahead of potential health issues. With routine health screenings, consultations with specialists, and mental wellness support, Wellness OPD ensures a holistic approach to your well-being.
          </p>
          <p className="text-paragraph mt-[10px] mb-[10px]">
            Most people assume that healthcare is only necessary when they’re ill. However, investing in preventive care through a Wellness OPD plan is a smarter choice. These plans include: 
          </p>
          <p className="text-paragraph">
           1. Regular health check-ups to monitor vital signs like cholesterol, blood pressure, and blood sugar levels.
          </p>
          <p className="text-paragraph">
           2. Mental health consultations to help manage stress, anxiety, and emotional wellness.
          </p>
          <p className="text-paragraph">
           3. Discounted lab tests and diagnostic services to ensure you get the best care at an affordable price.
          </p>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            Long-Term Financial Benefits
          </h4>
          <p className="text-paragraph mt-[10px]">
            You may wonder, "Why spend money on a Wellness OPD plan when I'm feeling fine?" The truth is, investing in preventive care is far more cost-effective than waiting for a health crisis to emerge. When you regularly monitor your health, you can catch problems early, which reduces the risk of complications and long-term medical costs. Treating conditions early can lead to shorter recovery times and lower overall treatment expenses.
          </p>
          <p className="text-paragraph mb-10 mt-[10px]">
            For example, if a small cholesterol issue goes unnoticed and leads to a heart condition, the cost of surgery or long-term medications will be far higher than the investment in a Wellness OPD plan that would have detected the problem early.
          </p>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            The Holistic Approach to Wellness
          </h4>
          <p className="text-paragraph mb-10 mt-[10px]">
            Wellness OPD also acknowledges that health isn’t just physical. It takes into account your mental health, nutrition, and lifestyle choices. By focusing on overall well-being, you’re not just treating diseases, but actively preventing them. Plans often include dietary consultations, stress management tips, and exercise plans designed to fit your personal needs.
          </p>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            Conclusion
          </h4>
          <p className="text-paragraph mb-10 mt-[10px]">
           Incorporating a Wellness OPD plan into your life is one of the best ways to stay healthy, reduce future healthcare expenses, and improve your overall quality of life. The earlier you detect potential issues, the easier they are to manage. Choose a Wellness OPD plan and make a smart investment in your future health today.
          </p>
        </div>
      </section>
      {/* blog end  */}


    </main>
  );
};

export default Blog2;
